export enum TaskStatus {
  New = 0,
  Pending = 1,
  Importing = 2,
  Completed = 3,
  Error = 4,
}
